import React from 'react';
const Loading = () => <div className="animated fadeIn pt-3 text-center">Chargement...</div>;

export default Loading